import * as React from 'react';
import LocationsContext from './context';
import useLocations from '../../hooks/useLocations';
import usePrevious from '../../hooks/usePrevious';

export default function LocationsProvider({
    children,
}: React.PropsWithChildren<unknown>): React.ReactElement {
    const locations = useLocations();
    const previousLocations = usePrevious(locations);
    const [context, setContext] = React.useState(() => ({ locations }));

    React.useEffect(() => {
        setContext({ locations });
    }, [locations, previousLocations]);

    return (
        <LocationsContext.Provider value={context}>
            {children}
        </LocationsContext.Provider>
    );
}
